import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setRadioValue } from "../redux/slices/radioSlice";
import InfoTooltip from "./Tooltip";

const RadioButtonGroup = ({ label, description, options, stateName, tooltip, hint = "Single Selection", error }) => {
  const dispatch = useDispatch();
  const selectedValue = useSelector((state) => state.radio.selectedValues[stateName] || 0);

  const handleChange = (event) => {
    dispatch(setRadioValue({ stateName, value: Number(event.target.value) }));
  };

  const [expanded, setExpanded] = useState(false);

  const MAX_CHAR_COUNT = 300;

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <div data-field={stateName} className={`mt-3 ${error ? "thick-error-border" : "radio-group-container"}`}>
      <fieldset className="form-section">
        <legend className="mb-3 fw-bold">
          {label}
          {tooltip && <InfoTooltip text={tooltip} />}
          <span className="badge bg-secondary ms-2" style={{ fontSize: "0.7rem" }}>{hint}</span>
        </legend>
        {description && (
          <div
            className="text-muted mb-4 ps-2 border-start border-3 border-secondary"
            style={{ fontSize: "0.95rem", lineHeight: "1.6"}}
          >
            <span dangerouslySetInnerHTML={{ __html: expanded ? description : description.slice(0, MAX_CHAR_COUNT) + (description.length > MAX_CHAR_COUNT ? "..." : "") }} />
            {description.length > MAX_CHAR_COUNT && (
              <button 
                className="btn btn-link p-0 ms-1"
                style={{ fontSize: "0.9rem", textDecoration: "none" }}
                onClick={toggleExpand}
              >
                <em>{expanded ? "Show Less" : "Show More"}</em>
              </button>
            )}
          </div>
        )}

        <div className="row">
          {options.map((option, index) => (
            <div className="col-12 col-md-6 col-lg-4" key={index}>
              <div className="form-check custom-radio">
                <input
                  className="form-check-input custom-radio-input"
                  type="radio"
                  name={stateName}
                  id={`${stateName}-${option.value}`}
                  value={option.value}
                  checked={selectedValue === Number(option.value)}
                  onChange={handleChange}
                />
                <label className="form-check-label custom-radio-label" htmlFor={`${stateName}-${option.value}`}>
                  {option.label}
                </label>
              </div>
            </div>
          ))}
        </div>
      </fieldset>
    </div>
  );
};

export default RadioButtonGroup;
